import { render, staticRenderFns } from "./ProductSync.vue?vue&type=template&id=685ff35a"
import script from "./ProductSync.vue?vue&type=script&lang=js"
export * from "./ProductSync.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports